import type { TestCaseTItem } from "../../core";

export type TCasesPredicateFindArg = {
  rootTreeItem: TestCaseTItem;
  predicate: (treeItem: TestCaseTItem) => boolean;
};
export type TCasesPredicateFindRtrn = null | TestCaseTItem;
export const tCasesPredicateFind = ({ predicate, rootTreeItem }: TCasesPredicateFindArg): TCasesPredicateFindRtrn => {
  if (predicate(rootTreeItem)) return rootTreeItem;
  if (rootTreeItem.type === "payload") return null;

  return rootTreeItem.children.reduce<TCasesPredicateFindRtrn>(
    (a, child) => (a === null ? tCasesPredicateFind({ predicate, rootTreeItem: child }) : a),
    null,
  );
};
